import IQueries from '@/interfaces/IQueries';

// Path with parameters
const vpns: IQueries = {
    vpns_list: {
        path: '/vpn/radius_vpn_servers',
        method: 'GET'
    },
    vpn_create: {
        path: '/vpn/radius_vpn_servers',
        method: 'POST'
    },
    vpn_detail: {
        path: '/vpn/radius_vpn_servers/',
        method: 'GET'
    },
    vpn_update: {
        path: '/vpn/radius_vpn_servers/',
        method: 'PUT'
    },
    vpn_remove: {
        path: '/vpn/radius_vpn_servers/',
        method: 'DELETE'
    }
};

export default vpns;